import { useSidebar } from "@hooks/useSidebar.jsx";
import ProfileCard from "@cards/card.profile.info";
import { useSelector } from "react-redux";
import { X } from "lucide-react";
import { useRole } from "@hooks/useRole";
import { Switch } from "antd";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import useAxiosLogout from "../hooks/useAxiosLogout";

// ✅ Custom hook for back button handling
const useBackHandler = () => {
  const { sidebarOpen, setSidebarOpen } = useSidebar();

  useEffect(() => {
    const handleBack = (event) => {
      if (sidebarOpen) {
        event.preventDefault();
        setSidebarOpen(false);
        window.history.pushState(null, "", window.location.href);
      }
    };

    window.addEventListener("popstate", handleBack);

    if (sidebarOpen) {
      window.history.pushState(null, "", window.location.href);
    }

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, [sidebarOpen, setSidebarOpen]);
};

const MobileSlidebar = () => {
  const { sidebarOpen, setSidebarOpen } = useSidebar();
  const { selectedRole, availableRoles, switchRole } = useRole();
  const profileData =useSelector((state) => state.profileReducer.profileDetails)
  const { logOut } = useAxiosLogout();

  const handleChange = () => {
    switchRole();
    // ❌ remove this if you don’t want sidebar to close on role switch
    setSidebarOpen(false);
  };

  

  const items =
    "text-gray-700 rounded-2xl dark:text-gray-200 poppins hover:bg-gray-100 dark:hover:bg-gray-950 text-sm py-2.5 px-3 text-capitalize text-decoration-none ";

  useBackHandler();

  return (
    <div
      className={`fixed inset-0 backdrop-blur-lg z-[9999999999] transition-opacity duration-400 p-2 ${
        sidebarOpen
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none"
      }`}
     
      onClick={() => setSidebarOpen(false)}
    >
      {/* Sidebar */}
      <div
        onClick={(e) => e.stopPropagation()}
        className={` w-[75vw] p-2 h-full bg-pri z-50 shadow-2xl transform transition-transform rounded-3xl d-flex flex-col justify-between duration-500 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div>
          {/* Close Button */}
          <div className="d-flex justify-between w-full p-3">
            <p className="syne font-semibold text-xl">Showstage</p>
            <button onClick={() => setSidebarOpen(false)}>
              <X size={20} />
            </button>
          </div>

          <ProfileCard profileData={profileData} close={()=>setSidebarOpen(false)} />

          {/* Sidebar Content */}
          <nav className="flex flex-col border-t py-2">
            {availableRoles?.length >= 2 && (
              <div
                className={`${items} d-flex w-100 justify-between`}
                onClick={(e) => e.stopPropagation()}
              >
                Switch to {selectedRole === "artist" ? "Agency" : "Artist"}
                <Switch
                  size="small"
                  checked={selectedRole === "agency"}
                  onChange={handleChange}
                />
              </div>
            )}

            {selectedRole==="artist" && <Link
              to="/artists"
              onClick={() => setSidebarOpen(false)}
              className={items}
            >
              Artists
            </Link>}
           
            {selectedRole==="agency" && <Link
              to="/discover"
              onClick={() => setSidebarOpen(false)}
              className={items}
            >
              Discover
            </Link>}
            {/* {selectedRole==="artist" && <Link
              to="/artist_profiles"
              onClick={() => setSidebarOpen(false)}
              className={items}
            >
              Artists
            </Link>} */}
            <Link
              to="/settings"
              onClick={() => setSidebarOpen(false)}
              className={items}
            >
              Settings
            </Link>
          </nav>

          <p
           onClick={logOut}
            className={`${items} font-semibold mt-2`}
          >
            Logout
          </p>
        </div>

        <p className="mont text-xs text-gray-700 dark:text-gray-200 text-center">Version 1.3</p>
      </div>
    </div>
  );
};

export default MobileSlidebar;
